import { collection } from 'firebase/firestore'
import { db } from './init-firebase'

export const foodCollectionRef = collection(db, 'foods')